import { WhatsAppInviteTemplateId, WhatsAppInviteTemplatePreview } from './whatsapp-invite-template.type'

/**
 * Predefined WhatsApp invitation templates (image previews) and id helpers.
 */
export class WhatsAppInviteTemplateModel {
  public static readonly DEFAULT_TEMPLATE_ID: WhatsAppInviteTemplateId = 1

  /** Legacy S3 preview order: id 1 uses whatsappTemplate3.png, id 3 uses whatsappTemplate1.png. */
  public static readonly PREVIEWS: readonly WhatsAppInviteTemplatePreview[] = [
    {
      id: 1,
      label: 'Template 1',
      previewUrl: 'https://micetribe-staging-frontend.s3.eu-west-3.amazonaws.com/library/whatsappTemplates/whatsappTemplate3.png'
    },
    {
      id: 2,
      label: 'Template 2',
      previewUrl: 'https://micetribe-staging-frontend.s3.eu-west-3.amazonaws.com/library/whatsappTemplates/whatsappTemplate2.png'
    },
    {
      id: 3,
      label: 'Template 3',
      previewUrl: 'https://micetribe-staging-frontend.s3.eu-west-3.amazonaws.com/library/whatsappTemplates/whatsappTemplate1.png'
    }
  ]

  /**
   * Returns the id when it is a known template (1–3), otherwise the default template id.
   * @param id - Raw template id (e.g. from API or input).
   */
  public static templateIdOrDefault(id: number | null | undefined): WhatsAppInviteTemplateId {
    if (id === 1 || id === 2 || id === 3) return id
    return WhatsAppInviteTemplateModel.DEFAULT_TEMPLATE_ID
  }

  /**
   * Preview image URL for a template id (falls back to the default template).
   * @param id - Template id (1–3).
   */
  public static previewUrlFor(id: WhatsAppInviteTemplateId): string {
    const preview = WhatsAppInviteTemplateModel.PREVIEWS.find((template) => template.id === id) ?? WhatsAppInviteTemplateModel.PREVIEWS[0]
    return preview.previewUrl
  }
}
